import React, { useState, useMemo } from "react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";

// CSVModal.js
export default function CSVModal({ activities, open, onClose, onExport }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 1. Filter activities ตามวันที่
  const filteredActivities = useMemo(() => {
    if (!startDate || !endDate) return [];
    return activities.filter((a) => {
      const date = a.activity_date || a.created_at?.slice(0, 10);
      return date >= startDate && date <= endDate;
    });
  }, [activities, startDate, endDate]);

  // 2. Export ฟังก์ชัน
  const handleExport = () => {
    if (filteredActivities.length === 0) return;
    onExport(filteredActivities);
  };

  // 3. UI
  return open ? (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-lg">
        <div className="mb-4 flex gap-2 items-center">
          <label>From: <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="border rounded px-2 py-1" /></label>
          <label>To: <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="border rounded px-2 py-1" /></label>
        </div>

        {/* 4. Preview Section */}
        <div className="mb-4 max-h-60 overflow-y-auto">
          {(!startDate || !endDate) ? (
            <div className="text-gray-400 text-center py-6">กรุณาเลือกช่วงวันที่</div>
          ) : filteredActivities.length === 0 ? (
            <div className="text-red-400 text-center py-6">ไม่มีข้อมูลในช่วงที่เลือก</div>
          ) : (
            <table className="w-full text-xs">
              <thead>
                <tr className="bg-gray-100">
                  <th className="py-1">วันที่</th>
                  <th>กิจกรรม</th>
                  <th>หมวด</th>
                  <th>เวลา</th>
                  <th>หมายเหตุ</th>
                </tr>
              </thead>
              <tbody>
                {filteredActivities.map((a, i) => (
                  <tr key={a.id || i} className="border-b">
                    <td className="py-1">{format(parseISO(a.activity_date || a.created_at?.slice(0, 10)), "yyyy-MM-dd")}</td>
                    <td>{a.activity}</td>
                    <td>{a.category}</td>
                    <td>{a.duration}</td>
                    <td>{a.note || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* 5. Action Buttons */}
        <div className="flex justify-between items-center gap-3">
          <button onClick={onClose} className="px-4 py-1 rounded bg-gray-200 hover:bg-gray-300">ปิด</button>
          <button
            onClick={handleExport}
            className={`px-4 py-1 rounded text-white ${filteredActivities.length === 0 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"}`}
            disabled={filteredActivities.length === 0}
          >Export CSV</button>
        </div>
      </div>
    </div>
  ) : null;
}